import {
  IonContent, IonInput, IonList,
  IonButton, IonCol, IonRow, useIonAlert,
} from '@ionic/react'
import React, { FC, useState } from 'react'
import * as moment from 'moment'
import { Icon } from '@iconify/react'
import CreatableSelect from 'react-select/creatable'
import mapboxgl from 'mapbox-gl'
import Select from 'react-select'
import Datetime from 'react-datetime'
import { getWebSocketURL } from '../../../channels/consumer'
import { StakeholderIcon } from '../../../helpers/UserIcon'
import { useActionCable } from '../../../hooks/channels/useActionCable'
import { useChannel } from '../../../hooks/channels/useChannel'
import { useEngagementData } from '../../../hooks/engagement/useEngagementData'
import { useAuth } from '../../../hooks/useAuth'
import { DMMessage } from './MessageCard'
import {
  StakeholderChat, StakeholderMessage, EngagementSupport, EngagementTone, EngagementType,
  TerrainType,
} from '../../types/OptimizedMaps'
import useApi from '../../../hooks/testHooks'
import { ZoneTypeButton } from '../../riskregister/StyledContainers'
import IssueIcon from './issue.svg'
import EngagementNoteIcon from './eng-note.svg'

/* eslint-disable react/no-array-index-key */

import 'react-datetime/css/react-datetime.css'

import axios from '../../../utils/axios'
import { ObscureBackground, OverlayContainer } from '../../GlobalContainers'
import { TagButton } from '../../incident-management/StyledContainers'
import { SimpleButton } from '../../maps/StyledContainers'

import { useWorkspace } from '../../../hooks/useWorkspace'
import { IncidentCause, User } from '../../types/GlobalTypes'

interface ConversationProps {
  dmRoom: StakeholderChat,
}

const DMConversation : FC<ConversationProps> = ({ dmRoom }) => {
  const [comment, setComment] = React.useState<string>('')
  const [roomId, setRoomId] = React.useState<number>(null)
  const [messages, setMessages] = React.useState<StakeholderMessage[]>([])

  /* Use this hooks to connect to socket server -> Have a look at chats to see implementation */
  const { actionCable } = useActionCable(getWebSocketURL())
  const { subscribe, unsubscribe, subscribed } = useChannel(actionCable)
  const { pushLatestMessage, msgType } = useEngagementData()
  const { user } = useAuth()
  const messagesScroll = React.useRef(null)
  const apiHook = useApi()
  const { workspace } = useWorkspace()
  const [selectedMessages, setSelectedMessages] = React.useState<string[]>([])
  const [selecting, setSelecting] = React.useState(false)
  const [chooseType, setChooseType] = React.useState(false)
  const [formType, setFormType] = React.useState('')

  const handleSendMessage = () => {
    if (comment === '') return
    /* TODO: Send message to backend */
    const newMessage = {
      id: 1,
      message: comment,
      user: { ...user, id: user.user_id },
      created_at: moment().format(),
      sender: 'domain',
    }

    const sendmessage = apiHook.sendDM({
      user_id: user.user_id, domain_id: workspace.id, stakeholder: dmRoom.recipient.id, message: comment, dm_type: msgType,
    }).then((result) => {
      console.log(result)
    })

    pushLatestMessage(newMessage, dmRoom)
    setComment('')

    /* If using socket server then there's no need to update this state as the socket server will send an array of messages just like chats */
    setMessages([...messages, newMessage])
  }

  React.useEffect(() => {
    // TODO: Connect to new room using hook
    // Have a look at the way chats connect to their respective room in Conversation.tsx
  }, [subscribed])

  React.useEffect(() => {
    // Every time the room changes then trigger connection to other room's socket
    if (dmRoom.id === roomId) {
      return
    }
    setRoomId(dmRoom.id)

    /* Will trigger the useEfect above, which will take care of connecting to a different socket room */
    unsubscribe()
  }, [dmRoom])

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    messagesScroll.current && messagesScroll.current.scrollToBottom()
  }, [messages])

  React.useEffect(() => {
    // Set the initial value for the messages state
    const messages = apiHook.getDMs({ domain_id: workspace.id, stakeholder: dmRoom.recipient.id, dm_type: msgType }).then((result) => {
      setMessages(result.dms)
    })
  }, [dmRoom.recipient])

  return (
    <div style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%',
      padding: '20px',
    }}
    >
      <IonRow className='ion-justify-content-between ion-align-items-center' style={{ borderBottom: '0.5px solid #747474', padding: '10px', marginBottom: '10px' }}>
        <IonRow className='ion-align-items-center long-and-truncated'>
          <StakeholderIcon {...dmRoom.recipient} selected />
          <h5 style={{
            color: 'black', fontSize: '1rem', flex: 1, marginLeft: '10px', maxWidth: 'fit-content',
          }}
          >{ dmRoom.recipient.name }
          </h5>
          {
            !selecting ? (
              <IonButton
                style={{ marginLeft: 'auto' }}
                onClick={() => {
                  setSelecting(true)
                }}
              >
                Select Messages
              </IonButton>
            )
              : (
                <>
                  <IonButton
                    style={{ marginLeft: 'auto' }}
                    onClick={() => {
                      setSelecting(false)
                      setSelectedMessages([])
                    }}
                  >
                    Cancel
                  </IonButton>
                  <IonButton
                    onClick={() => {
                      setSelecting(false)
                      setChooseType(true)
                    }}
                  >
                    Submit Report
                  </IonButton>
                </>
              )
          }
        </IonRow>
      </IonRow>
      <IonContent ref={messagesScroll} style={{ '--background': 'white' }} scrollEvents>
        <IonList style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column' }}>
          {messages.map((val) => (
            <DMMessage
              key={val.id} // or val.created_at or similar
              content={val.message}
              user={val.sender}
              created_at={val.created_at}
              sender={val.sender}
              select={selecting}
              checked={selectedMessages.some(msg => msg.id === val.id)}
              onCheckChange={(checked) => {
                setSelectedMessages((prev) =>
                  checked
                    ? [...prev, val]
                    : prev.filter((msg) => msg.id !== val.id))
                console.log('Selected messages:', selectedMessages)
              }}
            />
          ))}

        </IonList>
      </IonContent>
      <IonRow style={{ margin: '10px 0' }}>
        <IonInput
          placeholder='Type message...'
          style={{ flex: 1 }}
          value={comment}
          className='chats-input-field'
          onIonChange={(e) => setComment(e.detail.value)}
        />
        <IonButton onClick={handleSendMessage} style={{ '--background': '#0C9500', color: 'white', margin: '0 10px' }}>Send</IonButton>
      </IonRow>
      {chooseType && (
        <ChooseType
          onCancel={() => setChooseType(false)}
          onSelect={(type) => {
            console.log('Selected type:', type)
            setChooseType(false)
            setFormType(type)
            // You can do more here with `type`, e.g., submit a report, attach to message, etc.
          }}
        />
      )}
      {
        formType === 'Engagement Note' && (
          <EngagementNote
            setFormType={setFormType}
            selectedMessages={selectedMessages}
          />
        )
      }
      {
        formType === 'Issue' && (
          <Issue
            setFormType={setFormType}
            selectedMessages={selectedMessages}
          />
        )
      }
      {
        formType === 'Security Report' && (
          <Incident
            setFormType={setFormType}
            selectedMessages={selectedMessages}
          />
        )
      }
    </div>
  )
}

export default DMConversation

const ChooseType: FC<TypeProps> = ({ onCancel, onSelect }) => (
  <OverlayContainer style={{ zIndex: 25, width: '300px', borderRadius: '1em' }} className='terrain-add-popup'>
    <h5>Choose Report</h5>
    <p>Choose the type of report you wish to make with the selected messages.</p>
    <div>
      <ZoneTypeButton onClick={() => onSelect('Engagement Note')}>
        <img src={EngagementNoteIcon} alt='Engament icon' />
        <div className='zone-type-text'>
          <h6>Engagement Note</h6>
        </div>
      </ZoneTypeButton>
      <ZoneTypeButton onClick={() => onSelect('Issue')}>
        <img src={IssueIcon} alt='Blue Polygon' />
        <div className='zone-type-text'>
          <h6>Issue</h6>
        </div>
      </ZoneTypeButton>
      <ZoneTypeButton onClick={() => onSelect('Security Report')}>
        <div className='zone-type-text'>
          <h6>Security Report</h6>
        </div>
      </ZoneTypeButton>
    </div>
    <IonButton onClick={onCancel} style={{ '--background': '#8E151F' }}>Cancel</IonButton>
  </OverlayContainer>
)

export interface Details {
  subject: string,
  type?: EngagementType,
  date: moment.Moment,
  representatives: ({ value: User, label: string } | undefined) [],
  community: number,
  stakeholders: { value: number, label: string }[],
  orgs: { value: number, label: string }[],
  aim: string,
  tone?: EngagementTone,
  support?: EngagementSupport,
  summary: string,
  assets: any[],
  communities: any[],
}

export const buttonTypes = [EngagementType.PHONE_CALL, EngagementType.TEXT_MESSAGE_EXCHANGE, EngagementType.FACE_TO_FACE_MEETING, EngagementType.VIDEO_CALL, EngagementType.EMAIL]
export const buttonTones = [EngagementTone.AGGRESSIVE, EngagementTone.ANNOYED, EngagementTone.NORMAL, EngagementTone.POSITIVE, EngagementTone.ENTHUSIASTIC]
export const buttonSupports = [EngagementSupport.STRONGLY_OPPOSED, EngagementSupport.SOMEWHAT_OPPOSED, EngagementSupport.NORMAL, EngagementSupport.SOMEWHAT_IN_FAVOUR, EngagementSupport.VERY_IN_FAVOUR]

interface EngagementNoteProps {
  setFormType: React.Dispatch<React.SetStateAction<string>>,
  selectedMessages: any[]
}

const EngagementNote: FC<EngagementNoteProps> = ({ setFormType, selectedMessages }) => {
  const { stakeholders, setLoading, users, assets, communities } = useEngagementData()
  const [ionAlert] = useIonAlert()
  const [input, setInput] = useState<Details>({
    subject: '',
    date: moment(),
    representatives: [],
    community: null,
    stakeholders: [],
    orgs: [],
    aim: '',
    summary: selectedMessages
      .map((msg) => {
        const date = new Date(msg.created_at)
        const formattedDate = date.toLocaleDateString('en-GB') // dd/mm/yyyy
        const shortDate = formattedDate.slice(0, 6) + formattedDate.slice(8) // remove the "20" from year
        const stakeholder = stakeholders.find(s => s.id === msg.stakeholder_id)
        const senderName = stakeholder ? stakeholder.name : 'Unknown'
        return `${msg.message}\n${senderName}\n${shortDate}`
      })
      .join('\n\n'),
    assets: [],
    communities: [],
    type: EngagementType.TEXT_MESSAGE_EXCHANGE,
  })

  const { workspace } = useWorkspace()
  const mapRef = React.useRef<mapboxgl.Map>(null)
  const [marker, setMarker] = useState<mapboxgl.Marker>(null)

  const errorMessages = {
    subject: 'Engagement note must have a subject',
    // type: 'Engagement type not specified',
    // date: 'Date of the engagement not specified',
    // community: 'Engagement must have occurred at a given neighbourhood/community',
    // aim: 'Aim of engagement missing',
    // tone: 'Please specify the tone of the engagement',
    // support: 'Please specify the level of support toward the company',
    // summary: 'Summary of engagement missing',
  }

  const aims = [
    { id: 1, name: 'Communicating information' },
    { id: 2, name: 'Facilitating decision-making' },
    { id: 3, name: 'Identifying and mitigating impacts and risks' },
    { id: 4, name: 'Incident and grievance management' },
    { id: 4, name: 'Land access' },
    { id: 5, name: 'Managing commitments' },
    { id: 6, name: 'Maximising opportunities' },
    { id: 7, name: 'Understanding perceptions / managing expectations' },
  ]

  const handleClick = (e: mapboxgl.MapMouseEvent & mapboxgl.EventData) => {
    if (marker) return
    /* Place new marker on the specified zone */
    const markerTemp = new mapboxgl.Marker({ color: 'rgb(109, 0, 235)' })
      .setLngLat(e.lngLat)
      .addTo(mapRef.current)

    /* Add draggable functionalities */
    markerTemp.setDraggable(true)

    setMarker(markerTemp)
  }
  const handleClickRef = React.useRef(handleClick)
  handleClickRef.current = handleClick

  const chooseUserInvolved = (addUser: { value: User, label: string }, index: number) => {
    const copy = input.representatives.slice()
    copy.splice(index, 1, addUser)

    setInput({ ...input, representatives: copy })
  }

  const handleSubmit = () => {
    const keys = Object.keys(errorMessages)
    const findError = keys.find((val) => !input[val] || input[val] === '')

    if (!input.representatives.every((val) => val)) {
      ionAlert({
        header: 'Form Error',
        message: 'One or more representatives data seem to not be filled',
        buttons: [{ text: 'Ok' }],
      })
      return
    }

    if (findError) {
      ionAlert({
        header: 'Form Error',
        message: errorMessages[findError],
        buttons: [{ text: 'Ok' }],
      })

      return
    }
    const filteredRepresentatives = input.representatives.reduce<{ value: User, label: string }[]>((list, current) => {
      if (list.find(({ value }) => value.id === current.value.id)) {
        return list
      }
      return [...list, current]
    }, [])

    setLoading(true)
    axios.post('/api/v2/engagement_note/create_note', {
      domain_id: workspace.id,
      alias_name: input.subject,
      subject: input.subject,
      type: input.type,
      date: input.date.format(),
      communities: input.communities.map(({ value }) => value),
      aim: input.aim,
      tone: input.tone,
      support: input.support,
      summary: input.summary,
      reps: filteredRepresentatives?.map(({ value }) => value.id) ?? null,
      stakeholders: input.stakeholders.map(({ value }) => value),
      orgs: input.orgs.map(({ value }) => value),
      assets: input.assets.map(({ value }) => value),
    }).then(({ data }) => {
      if (data.message === 'you have not created a note.') {
        ionAlert({
          header: 'Server Error',
          message: data.message,
          buttons: [{ text: 'Ok' }],
        })
        return
      }
      ionAlert({
        header: 'Success',
        message: 'Engagement Note created successfully',
        buttons: [{ text: 'Ok' }],
      })
    }).catch((error) => {
      console.error('Server Error:', error)
      ionAlert({
        header: 'Server Error',
        message: error?.message || 'Unknown server error',
        buttons: [{ text: 'Ok' }],
      })
    }).finally(() => {
      setLoading(false)
      setFormType('')
    })
  }

  return (
    <>
      <ObscureBackground style={{ zIndex: 20 }} />
      <OverlayContainer
        style={{
          zIndex: 25, height: '80%', overflow: 'hidden', width: '60%', borderRadius: '1em',
        }}
        className='terrain-add-popup'
      >
        <div style={{ maxHeight: '100%', overflow: 'hidden' }} className='risk-assessment-list'>
          <IonRow style={{ marginBottom: '10px' }} className='ion-justify-content-between ion-align-items-center'>
            <h5 style={{ marginBottom: 0 }}>Add Engagement Note</h5>
            <SimpleButton onClick={() => setFormType('')}>Close X</SimpleButton>
          </IonRow>
          <div style={{ flex: 1, overflow: 'auto' }}>
            <div className='terrain-form-field'>
              <h6>Subject</h6>
              <input
                placeholder='Subject of engagement'
                type='text'
                value={input.subject}
                onChange={(e) => setInput({ ...input, subject: e.target.value })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Key Asset</h6>
              <CreatableSelect
                isMulti
                placeholder='Select Key Asset(s)'
                name='colors'
                className='select-container'
                id='journey-passengers'
              // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
                options={assets?.map(({ id, name }) => ({ label: name, value: id }))}
                value={input.assets}
                onChange={(selected) => setInput({ ...input, assets: selected })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Type</h6>
              {
                buttonTypes?.map((val) => (
                  <TagButton
                    key={val}
                    onClick={() => setInput({ ...input, type: val })}
                    style={{ backgroundColor: (val === input.type) ? '#326771' : 'white', color: (val === input.type) ? 'white' : '#326771' }}
                  >
                    { val }
                  </TagButton>
                ))
              }
            </div>
            <div className='terrain-form-field'>
              <h6>Date of Engagement</h6>
              <Datetime
                dateFormat='YYYY-MM-DD'
                inputProps={{
                  placeholder: 'Select Date',
                  readOnly: true,
                  style: { backgroundColor: 'white' },
                }}
                value={input.date}
                onChange={(e) => setInput({ ...input, date: e as moment.Moment })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Company Representatives</h6>
              {
                input.representatives.map((val, index) => (
                  <IonRow key={index} style={{ margin: '10px 0' }}>
                    <IonCol size='3'>
                      <Select
                        placeholder='Select user'
                        name='supervisor'
                        id='select-supervisor-container'
                        className='select-container'
                    // eslint-disable-next-line no-undef
                        value={val}
                        menuPortalTarget={document.body}
                        options={users.map((userVal) => ({ value: userVal, label: `${userVal.first_name} ${userVal.final_name}` }))}
                        onChange={(selected) => chooseUserInvolved(selected, index)}
                      />
                    </IonCol>
                    <IonCol size='3'>
                      <p className='incident-management-text-field'>{ val ? val.value.email : 'Email' }</p>
                    </IonCol>
                    <IonCol size='3'>
                      <p className='incident-management-text-field'>{ val && val.value.phone_number ? val.value.phone_number : 'Phone No.' }</p>
                    </IonCol>
                    <IonCol size='3'>
                      <p className='incident-management-text-field'>{ val && val.value.alternative_phone_number ? val.value.alternative_phone_number : 'Alternative Phone No.' }</p>
                    </IonCol>
                  </IonRow>
                ))
              }
              <IonRow className='ion-justify-content-end'>
                <SimpleButton
                  onClick={() => setInput({ ...input, representatives: [...input.representatives, undefined] })}
                >
                  Add Person <Icon icon='ic:baseline-plus' style={{ marginLeft: '10px' }} />
                </SimpleButton>
              </IonRow>
            </div>
            <div className='terrain-form-field'>
              <h6>Neighbourhood/Community</h6>
              <CreatableSelect
                isMulti
                placeholder='Select Communities'
                name='community'
                className='select-container'
                id='community-select'
                menuPortalTarget={document.body}
                options={communities?.map(({ id, name }) => ({ value: id, label: name }))}
                value={input.communities}
                onChange={(selected) => setInput({ ...input, communities: selected })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Attending Organisation</h6>
              <CreatableSelect
                isMulti
                placeholder='Select Organisations'
                name='colors'
                className='select-container'
                id='journey-passengers'
              // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
                options={stakeholders?.filter(({ type }) => type === 'Organisation').map(({ id, name }) => ({ label: name, value: id }))}
                value={input.orgs}
                onChange={(selected) => setInput({ ...input, orgs: selected })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Attending Individuals</h6>
              <CreatableSelect
                isMulti
                placeholder='Select Individuals'
                name='colors'
                className='select-container'
                id='journey-passengers'
              // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
                options={stakeholders?.filter(({ type }) => type === 'Individual').map(({ id, name }) => ({ label: name, value: id }))}
                value={input.stakeholders}
                onChange={(selected) => setInput({ ...input, stakeholders: selected })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>What was the aim?</h6>
              <select
                value={input.aim}
                onChange={(e) => setInput({ ...input, aim: e.target.value })}
                style={{ padding: '5px 10px' }}
              >
                <option value='' disabled>Select the aim</option>
                {
                  aims?.map((val) => (
                    <option key={val.id} value={val.name}>{ val.name }</option>
                  ))
                }
              </select>
            </div>
            <div className='terrain-form-field'>
              <h6>What was the general tone of the participants?</h6>
              {
                buttonTones?.map((val) => (
                  <TagButton
                    key={val}
                    onClick={() => setInput({ ...input, tone: val })}
                    style={{ backgroundColor: (val === input.tone) ? '#326771' : 'white', color: (val === input.tone) ? 'white' : '#326771' }}
                  >
                    { val }
                  </TagButton>
                ))
              }
            </div>
            <div className='terrain-form-field'>
              <h6>What was the general level of support/opposition to the company?</h6>
              {
                buttonSupports?.map((val) => (
                  <TagButton
                    key={val}
                    onClick={() => setInput({ ...input, support: val })}
                    style={{ backgroundColor: (val === input.support) ? '#326771' : 'white', color: (val === input.support) ? 'white' : '#326771' }}
                  >
                    { val }
                  </TagButton>
                ))
              }
            </div>
            <div className='terrain-form-field form-desc'>
              <h6>Summary</h6>
              <textarea value={input.summary} onChange={(e) => setInput({ ...input, summary: e.target.value })} />
            </div>
          </div>
          <IonRow className='ion-justify-content-end'>
            <IonButton onClick={() => setFormType('')} style={{ '--background': '#8E151F' }}>Cancel</IonButton>
            <IonButton onClick={handleSubmit} style={{ '--background': '#0C9500' }}>Submit</IonButton>
          </IonRow>
        </div>
      </OverlayContainer>
    </>
  )
}

interface IssDetails {
  title: string,
  type: '' | TerrainType,
  date: moment.Moment,
  description: string,
  stakeholders: { value: number, label: string }[],
  areas: { value: number, label: string }[],
}

export const TerrainTypes = [TerrainType.QUESTION, TerrainType.REQUEST_FOR_INFORMATION, TerrainType.GENERAL_PERCEPTION, TerrainType.FRICTION, TerrainType.OTHER]

interface IssueProps {
  setFormType: React.Dispatch<React.SetStateAction<string>>,
  selectedMessages: any[]
}

const Issue: FC<IssueProps> = ({ setFormType, selectedMessages }) => {
  const { stakeholders, setLoading, communities, causes } = useEngagementData()
  const [input, setInput] = useState<IssDetails>({
    title: '',
    type: '',
    date: moment(),
    description: selectedMessages
      .map((msg) => {
        const date = new Date(msg.created_at)
        const formattedDate = date.toLocaleDateString('en-GB') // dd/mm/yyyy
        const shortDate = formattedDate.slice(0, 6) + formattedDate.slice(8) // remove the "20" from year
        const stakeholder = stakeholders.find(s => s.id === msg.stakeholder_id)
        const senderName = stakeholder ? stakeholder.name : 'Unknown'
        return `${msg.message}\n${senderName}\n${shortDate}`
      })
      .join('\n\n'),
    stakeholders: [],
    areas: [],
  })
  const { workspace } = useWorkspace()
  const [selectedCauses, setSelectedCauses] = useState<(IncidentCause & { selected: boolean })[]>([])

  const [ionAlert] = useIonAlert()

  const errorMessages = {
    title: 'No title provided',
    type: 'No type provided',
    description: 'Please, briefly describe the issue',
  }

  const selectCause = (index: number) => {
    const copy = selectedCauses.slice()
    copy.splice(index, 1, { ...copy[index], selected: !copy[index].selected })

    setSelectedCauses(copy)
  }

  const handleSubmit = () => {
    const keys = Object.keys(errorMessages)
    const errorKey = keys.find((val) => !input[val] || input[val] === '')

    if (errorKey) {
      ionAlert({
        header: 'Form Error',
        message: errorMessages[errorKey],
        buttons: [{ text: 'Ok' }],
      })
      return
    }

    const selectedStakeholders = stakeholders?.filter(({ id }) => input.stakeholders.find(({ value }) => value === id))
    const filteredCauses = selectedCauses?.filter(({ selected }) => selected)
    const selectedAreas = communities?.filter(({ id }) => input.areas.find(({ value }) => value === id))

    setLoading(true)
    axios.post('/api/v2/issue/create_issue', {
      domain_id: workspace.id,
      title: input.title,
      type: input.type,
      received: input.date.format(),
      description: input.description,
      issues: filteredCauses?.map(({ id }) => id),
      community: selectedAreas?.map(({ id }) => id),
      stakeholders: selectedStakeholders?.map(({ id }) => id),
    }).then(({ data }) => {
      if (data.message === 'you have not created a issue.') {
        ionAlert({
          header: 'Server Error',
          message: data.message,
          buttons: [{ text: 'Ok' }],
        })
        return
      }
      ionAlert({
        header: 'Success',
        message: 'Issue created successfully',
        buttons: [{ text: 'Ok' }],
      })
    }).catch((error) => {
      console.error('Server Error:', error)
      ionAlert({
        header: 'Server Error',
        message: error?.message || 'Unknown server error',
        buttons: [{ text: 'Ok' }],
      })
    }).finally(() => {
      setLoading(false)
      setFormType('')
    })
  }

  React.useEffect(() => {
    setSelectedCauses(causes?.map((val) => ({ ...val, selected: false })))
  }, [])

  const typeOptions = [
    { label: 'Economic & Livelihood', value: 'Economic & Livelihood' },
    { label: 'Community Relations', value: 'Community Relations' },
    { label: 'Health, Safety & Well-being', value: 'Health, Safety & Well-being' },
    { label: 'Security & Conflict', value: 'Security & Conflict' },
    { label: 'Environmental Impact', value: 'Environmental Impact' },
    { label: 'Legal & Regulatory Compliance', value: 'Legal & Regulatory Compliance' },
    { label: 'Cultural Sensitivity & Heritage Preservation', value: 'Cultural Sensitivity & Heritage Preservation' },
  ]

  return (
    <>
      <ObscureBackground style={{ zIndex: 20 }} />
      <OverlayContainer style={{ zIndex: 25, height: '80%', overflow: 'hidden', borderRadius: '1em' }} className='terrain-add-popup'>
        <div style={{ maxHeight: '100%', overflow: 'hidden' }} className='risk-assessment-list'>
          <IonRow style={{ marginBottom: '10px' }} className='ion-justify-content-between ion-align-items-center'>
            <h5 style={{ marginBottom: 0 }}>Add Issue</h5>
            <SimpleButton onClick={() => setFormType('')}>Close X</SimpleButton>
          </IonRow>
          <div style={{ flex: 1, overflow: 'auto' }}>
            <p>Issues are questions, requests for information, or general perceptions. If not addressed well, issues may become grievances. Issues do not have to be registered as grievances,
              but they should be recorded so that emerging trends can be identified and addressed before they escalate.
            </p>
            <div className='terrain-form-field'>
              <h6>Title</h6>
              <input
                placeholder='Give this issue a title'
                type='text'
                value={input.title}
                onChange={(e) => setInput({ ...input, title: e.target.value })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Issue Type</h6>
              <select
                value={input.type}
                onChange={(e) => setInput({ ...input, type: e.target.value as TerrainType })}
                style={{ padding: '5px 10px' }}
              >
                <option value='' disabled>Select a type</option>
                {
                  typeOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))
                }
              </select>
            </div>
            <div className='terrain-form-field'>
              <h6>Date Received</h6>
              <Datetime
                dateFormat='YYYY-MM-DD'
                inputProps={{
                  placeholder: 'Select Date',
                  readOnly: true,
                  style: { backgroundColor: 'white' },
                }}
                value={input.date}
                onChange={(e) => setInput({ ...input, date: e as moment.Moment })}
              />
            </div>
            <div className='terrain-form-field form-desc'>
              <h6>Description</h6>
              <textarea value={input.description} onChange={(e) => setInput({ ...input, description: e.target.value })} />
            </div>
            <div className='terrain-form-field form-desc'>
              <h6>Underlying Causes</h6>
              {
                selectedCauses?.map((val, index) => (
                  <TagButton
                    key={val.id}
                    onClick={() => selectCause(index)}
                    style={{ backgroundColor: (val.selected) ? '#326771' : 'white', color: (val.selected) ? 'white' : '#326771' }}
                  >
                    { val.name }
                  </TagButton>
                ))
              }
            </div>
            <div className='terrain-form-field'>
              <h6>Associated Stakeholders</h6>
              <CreatableSelect
                isMulti
                placeholder='Select Stakeholders'
                name='colors'
                className='select-container'
                id='journey-passengers'
              // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
                options={stakeholders?.map(({ id, name }) => ({ value: id, label: name }))}
                value={input.stakeholders}
                onChange={(selected) => setInput({ ...input, stakeholders: selected })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Relevant Areas</h6>
              <CreatableSelect
                isMulti
                placeholder='Select Areas'
                name='colors'
                className='select-container'
                id='journey-passengers'
              // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
                options={communities?.map(({ id, name }) => ({ label: name, value: id }))}
                value={input.areas}
                onChange={(selected) => setInput({ ...input, areas: selected })}
              />
            </div>
          </div>
          <IonRow className='ion-justify-content-end'>
            <IonButton onClick={() => setFormType('')} style={{ '--background': '#8E151F' }}>Cancel</IonButton>
            <IonButton onClick={handleSubmit} style={{ '--background': '#0C9500' }}>Submit</IonButton>
          </IonRow>
        </div>
      </OverlayContainer>
    </>
  )
}

interface IncidentProps {
  setFormType: React.Dispatch<React.SetStateAction<string>>,
  selectedMessages: any[]
}

const Incident: FC<IncidentProps> = ({ setFormType, selectedMessages }) => {
  const { stakeholders, setLoading, communities, causes } = useEngagementData()

  const [input, setInput] = useState<any>({
    title: '',
    type: '',
    date: moment(),
    description: selectedMessages
      .map((msg) => {
        const date = new Date(msg.created_at)
        const formattedDate = date.toLocaleDateString('en-GB') // dd/mm/yyyy
        const shortDate = formattedDate.slice(0, 6) + formattedDate.slice(8) // remove the "20" from year
        const stakeholder = stakeholders.find(s => s.id === msg.stakeholder_id)
        const senderName = stakeholder ? stakeholder.name : 'Unknown'
        return `${msg.message}\n${senderName}\n${shortDate}`
      })
      .join('\n\n'),
    stakeholders: [],
    areas: [],
  })
  const { workspace } = useWorkspace()
  const apiHook = useApi()
  const [ionAlert] = useIonAlert()

  const [incidentTypes, setIncidentTypes] = useState([])
  const [fillForm, setFillForm] = useState(false)
  const contentRef = React.useRef(null)

  React.useEffect(() => {
    if (incidentTypes && incidentTypes.length) return

    /* Fecth incidents */
    axios.get('/api/v1/types')
      .then((response) => {
        setIncidentTypes(response.data.types.sort((a, b) => {
          if (a < b) return -1
          if (b < a) return 1
          return 0
        }))
        setInput({ ...input, incident_type: '' })
      })
  }, [])

  const handleChange = (e) => setInput({ ...input, [e.target.name]: e.target.value })

  const handleSubmit = () => {
    setLoading(true)
    apiHook.tryIncident('', input.description, input.longitude, input.latitude, input.date, input.incident_type.label, input.fatalities,
      workspace.id, input.county_id, input.nearest).then(({ id }) => {
      setLoading(false)
      setFormType('')
      ionAlert({
        header: 'Success',
        message: 'Security Report created successfully',
        buttons: [{ text: 'Ok' }],
      })
    })
    return true
  }

  return (
    <>
      <ObscureBackground style={{ zIndex: 20 }} />
      <OverlayContainer style={{ zIndex: 25, height: '80%', overflow: 'hidden', borderRadius: '1em' }} className='terrain-add-popup'>
        <div style={{ maxHeight: '100%', overflow: 'hidden' }} className='risk-assessment-list'>
          <IonRow style={{ marginBottom: '10px' }} className='ion-justify-content-between ion-align-items-center'>
            <h5 style={{ marginBottom: 0 }}>Add Security Report</h5>
            <SimpleButton onClick={() => setFormType('')}>Close X</SimpleButton>
          </IonRow>
          <div style={{ flex: 1, overflow: 'auto' }}>
            <div className='terrain-form-field'>
              <h6>Date of Incident</h6>
              <IonRow style={{ flex: 1 }}>
                <IonInput
                  placeholder='Latitude'
                  value={input.latitude}
                  name='latitude'
                  type='number'
                  max='90'
                  min='-90'
                  onIonChange={(e) => {
                    handleChange(e)
                  }}
                />
                <IonInput
                  placeholder='Longitude'
                  value={input.longitude}
                  type='number'
                  name='longitude'
                  max='180'
                  min='-180'
                  onIonChange={(e) => {
                    handleChange(e)
                  }}
                />
              </IonRow>
            </div>
            <div className='terrain-form-field'>
              <h6>Incident Category</h6>
              <CreatableSelect
                placeholder='Select Category'
                name='colors'
                className='select-container'
                id='journey-passengers'
              // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
                options={incidentTypes?.map((incident) => ({ label: incident, value: incident }))}
                value={input.incident_type}
                onChange={(selected) => setInput({ ...input, incident_type: selected })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Date of Incident</h6>
              <Datetime
                dateFormat='YYYY-MM-DD'
                inputProps={{
                  placeholder: 'Select Date',
                  readOnly: true,
                  style: { backgroundColor: 'white' },
                }}
                value={input.date}
                onChange={(e) => setInput({ ...input, date: e as moment.Moment })}
              />
            </div>
            <div className='terrain-form-field'>
              <h6>Fatalities</h6>
              <IonInput id='incident-fatalities' name='fatalities' value={input.fatalities} onIonChange={handleChange} type='number' min='0' max='1000' style={{ textAlign: 'right' }} required />
            </div>
            <div className='terrain-form-field'>
              <h6>Nearest village/town/city to event</h6>
              <input
                placeholder='Enter nearest location'
                type='text'
                value={input.nearest}
                onChange={(e) => setInput({ ...input, nearest: e.target.value })}
              />
            </div>
            <div className='terrain-form-field form-desc'>
              <h6>Description of event</h6>
              <textarea value={input.description} onChange={(e) => setInput({ ...input, description: e.target.value })} />
            </div>
          </div>
          <IonRow className='ion-justify-content-end'>
            <IonButton onClick={() => setFormType('')} style={{ '--background': '#8E151F' }}>Cancel</IonButton>
            <IonButton onClick={() => handleSubmit()} style={{ '--background': '#0C9500' }}>Submit</IonButton>
          </IonRow>
        </div>
      </OverlayContainer>
    </>
  )
}
